module.exports = __webpack_public_path__ + "static/media/menu.eeb4bd31.svg";